import { Account } from "@/features/account/account";

export const Route = createFileRoute({
  component: Account,
});
